/**
 * created by xcc
 * 用户管理   sys
 */

import React, {Component} from 'react';
import {Table, Modal, Input, message} from "antd";
import PropTypes from 'prop-types';
import {Button} from "antd/lib/index";
import * as Action from '../../../actions/UserManagementSys';
import Base64 from 'base-64';

class UserManagementSys extends Component {
    static defaultProps={
        newSecondSelectColor:"#0050B3"
    };
    static propTypes={
        dataList:PropTypes.array.isRequired,
    }
    constructor(props) {
        super(props);
        this.state={
            resetPwdValue:"",
            confirmPwdValue:"",
            forbiddenVisible:false,
            deleteVisible:false,
            resetPwdVisible:false,
            liftBanVisible:false,
            pwdStr:"",
            currentAccount:"",
            selectedStatus:false,
            currentName:[],
            pwdLevel:""


        }
    }
    columns=[
        {
            key:"1",
            title:"姓名(账号)",
            dataIndex:"name(account)",
            width:"15%",
            ellipsis:true,
            align:"center",
            textWrap:"word-break",
            render:(value,row,index)=>{
                return(
                    <div onClick={()=>this.props.clickName(row)} style={{cursor:"pointer",overflow:"hidden",textOverflow:"ellipsis",lineClamp:1,whiteSpace:"nowrap"}}>{row.name}</div>
                )
            }
        },
        {
            key:"2",
            title:"角色",
            dataIndex:"role",
            width:"15%",
            ellipsis:true,
            align:"center",
            textWrap:"word-break",
            render:(value,row,index)=>{
                return(
                    <div>{this.renderRole(row)}</div>
                )
            }
        },
        {
            key:"3",
            title:"媒体",
            dataIndex:"media",
            width:"15%",
            ellipsis:true,
            align:"center",
            textWrap:"word-break",
            render:(value,row,index)=>{
                return(
                    <div>{this.renderMedia(row)}</div>
                )
            }

        },
        {
            key:"4",
            title:"部门",
            dataIndex:"dept",
            width:"15%",
            ellipsis:true,
            align:"center",
            textWrap:"word-break",
            render:(value,row,index)=>{
                return(
                    <div>{this.renderDept(row)}</div>
                )
            }

        },
        {
            key:"5",
            title:"修改密码时间",
            dataIndex:"updatePwdTime",
            width:"15%",
            ellipsis:true,
            align:"center",
            textWrap:"word-break",
            render:(value,row,index)=>{
                return(
                    <div style={{cursor:"pointer",overflow:"hidden",textOverflow:"ellipsis",lineClamp:1,whiteSpace:"nowrap"}}>
                        {row.prevUpdatePWDTime}
                    </div>
                )
            }

        },
        {
            key:"6",
            title:"操作",
            dataIndex:"operate",
            width:"15%",
            ellipsis:true,
            align:"center",
            textWrap:"word-break",
            render:(value,row,index)=>{
                return(
                    <div>{this.renderOperate(row)}</div>
                )
            }

        },
    ]


    //重置密码
    resetPwdOk=()=>{
        let pwd=this.state.pwdStr+this.state.resetPwdValue;
        let encodePwd=Base64.encode(pwd);
        if(!this.state.resetPwdValue){
            message.info("请输入新密码");
            return;
        }
        if(!this.state.confirmPwdValue){
            message.info("请输入确认密码");
            return;
        }
        if(this.state.resetPwdValue!==this.state.confirmPwdValue){
            message.info("两次输入密码不一致");
            return;
        }
        if(this.state.resetPwdValue.length < 7 || this.state.resetPwdValue.length > 20){
            message.info("密码长度为7-20个字符！");
            return;
        }
        let ls = 0;
        if(this.state.resetPwdValue.match(".*[0-9]+.*")){
            ls++;
        }
        if(this.state.resetPwdValue.match(".*[a-z]+.*")){
            ls++;
        }
        if(this.state.resetPwdValue.match(".*[A-Z]+.*")){
            ls++;
        }
        if(this.state.resetPwdValue.match(".*[~!@#$%^&*()_+|<>,.?/:;'\\[\\]{}\"]+.*")){
            ls++;
        }
        if(this.state.pwdLevel === '1'){
            if(ls < 2){
                message.info("密码至少包含两种以上字符！");
            }
        }else if (this.state.pwdLevel === '2'){
            if(ls < 3){
                message.info("密码至少包含三种以上字符！");
            }
        }
            if(ls >= 3){
                this.getResetPwdValue(this.state.currentAccount,encodePwd);
                this.setState({
                    resetPwdVisible:false,
                    resetPwdValue:"",
                    confirmPwdValue:""
                })
            }
    }

    resetPwdCancel=()=>{
        this.setState({
            resetPwdVisible:false,
            resetPwdValue:"",
            confirmPwdValue:""
        })
    }
    resetPwd(item){
        console.log(item);
        this.getPwdLevel();
        this.getPwdStr();
        this.setState({
            resetPwdVisible:true,
            currentAccount:item.account
        })
    }

    //得到密码级别
    getPwdLevel(){
        Action.getPwdLevelData({},(res)=>{
            let pwdLevel="";
            if(res){
                pwdLevel=res.dictValue;
            }
            this.setState({
                pwdLevel
            })
        })
    }

    //得到重置密码字符串
    getPwdStr(){
        Action.getResetPwdStr({},(res)=>{
            if(res && res.data){
                this.setState({
                    pwdStr:res.data
                })
            }
        })
    }

    //重置密码
    getResetPwdValue(currentAccount,encodePwd){
        let params={
            account:currentAccount,
            pwd:encodePwd
        }
        Action.getResetPwdData(params,(res)=>{
            console.log(res);
            if(res.data){
                message.success("密码重置成功");
                this.props.pageChange();
            }else{
                message.error("密码重置失败");
            }
        })
    }

    //禁用
    getForbiddenDatabase(){
        let params={
            useraccount:this.state.currentAccount,
            status:0
        }
        Action.getForbiddenData(params,(res)=>{
            if(res){
                message.success("禁用成功");
                this.props.pageChange();
            }else{
                message.error("禁用失败");
            }
        })
    }
    //解禁
    getLiftBanDatabase(){
        let params={
            useraccount:this.state.currentAccount,
            status:1
        }
        Action.getForbiddenData(params,(res)=>{
            if(res){
                message.success("解禁成功");
                this.props.pageChange();
            }else{
                message.error("解禁失败");
            }
        })
    }

    //删除
    deleteOk=()=>{
        this.getDeleteDatabase();
        this.setState({
            deleteVisible:false
        })
    }

    deleteCancel=()=>{
        this.setState({
            deleteVisible:false
        })
    }

    getDeleteDatabase(){
        let params={
            useraccounts:this.state.currentAccount,
        }
        Action.getDeleteData(params,(res)=>{
            if(res){
                message.success("删除成功");
                this.props.pageChange();
            }else{
                message.error("删除失败");
            }
        })
    }

    //禁用
    forbiddenOk=()=>{
        this.getForbiddenDatabase();
        this.setState({
            forbiddenVisible:false
        })
    }

    forbiddenCancel=()=>{
        this.setState({
            forbiddenVisible:false
        })
    }

    //解禁
    liftBanOk=()=>{
        this.getLiftBanDatabase();
        this.setState({
            liftBanVisible:false
        })
    }

    liftBanCancel=()=>{
        this.setState({
            liftBanVisible:false
        })
    }

    renderRole=(item)=>{
        let roles=[];
        item.allRole.forEach((roleItem,roleIndex)=>{
            roles.push(roleItem.roleName)
        })
        return(
            <div title={roles.join(",")} style={{cursor:"pointer",overflow:"hidden",textOverflow:"ellipsis",lineClamp:1,whiteSpace:"nowrap"}}>{roles.join(",")}</div>
        )
    }

    renderMedia=(item)=>{
        let medias=[];
        item.allMedia.forEach((mediaItem,mediaIndex)=>{
            medias.push(mediaItem.name)
        })
        return(
            <div title={medias.join(",")} style={{cursor:"pointer",overflow:"hidden",textOverflow:"ellipsis",lineClamp:1,whiteSpace:"nowrap"}}>{medias.join(",")}</div>
        )
    }

    renderDept=(item)=>{
        let dept=[];
        item.allDept.forEach((mediaItem,mediaIndex)=>{
            dept.push(mediaItem.name)
        })
        return(
            <div style={{cursor:"pointer",overflow:"hidden",textOverflow:"ellipsis",lineClamp:1,whiteSpace:"nowrap"}}>{dept.join(",")}</div>
        )
    }
    renderOperate=(item)=>{
        let disabledStatus=item.status;
        let statusOperate;
        if(disabledStatus===1){
            statusOperate=(
                <div style={{margin:"0px 5px"}}><Button size="small" type="primary" onClick={()=>this.setState({liftBanVisible:true,currentAccount:item.account})}>解禁</Button></div>
            )
        }else{
            statusOperate=(
                <div style={{margin:"0px 5px"}}>
                    <Button size="small" type="danger" onClick={()=>this.setState({forbiddenVisible:true,currentAccount:item.account})}>禁用</Button>
                </div>
            )
        }
        return(
            <div style={{display:"flex",alignItems:"center"}}>
                <div><Button size="small" type="primary" style={{backgroundColor:this.props.newSecondSelectColor}} onClick={()=>this.resetPwd(item)}>重置密码</Button></div>
                {statusOperate}
                <div><Button size="small" type="danger" onClick={()=>this.setState({deleteVisible:true,currentAccount:item.account})}>删除</Button></div>
            </div>
        )
    }

    render() {
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {},
            onSelect: (record, selected, selectedRows) => {
                if(selected){
                    let currentName=[];
                    selectedRows.forEach(item=>{
                        currentName.push(item.name)
                    })
                    this.setState({
                        selectedStatus:selected,
                        currentName:currentName
                    })
                }
                if(!selected){
                    this.setState({
                        selectedStatus:selected,
                    })
                }

            },
            onSelectAll: (selected, selectedRows, changeRows) => {},
        };
        return (
            <div>
                <Table rowSelection={rowSelection} rowKey={record => record.id} dataSource={this.props.dataList} columns={this.columns} pagination={false}/>
                <Modal
                    title="信息"
                    visible={this.state.resetPwdVisible}
                    onOk={this.resetPwdOk}
                    onCancel={this.resetPwdCancel}
                    width="400px"
                    centered
                >
                    <Input placeholder="请输入密码" value={this.state.resetPwdValue} onChange={(e)=>this.setState({resetPwdValue:e.target.value})}/>
                    <Input style={{marginTop:"10px"}} placeholder="请确认密码" value={this.state.confirmPwdValue} onChange={(e)=>this.setState({confirmPwdValue:e.target.value})}/>
                    <div style={{marginLeft: "15px",marginTop:"10px",height: "50px"}}>
                        <span style={{color: "red"}}>注：1.新密码长度必须为7至20个字符；2.新密码至少包含数字、大写字母、小写字母、特殊字符中的三种</span>
                    </div>

                </Modal>
                <Modal
                    title="信息"
                    visible={this.state.deleteVisible}
                    onOk={this.deleteOk}
                    onCancel={this.deleteCancel}
                    width="300px"
                    centered
                >
                    确定要删除吗？
                </Modal>
                <Modal
                    title="信息"
                    visible={this.state.forbiddenVisible}
                    onOk={this.forbiddenOk}
                    onCancel={this.forbiddenCancel}
                    width="300px"
                    centered
                >
                    确定要禁用吗？
                </Modal>
                <Modal
                    title="信息"
                    visible={this.state.liftBanVisible}
                    onOk={this.liftBanOk}
                    onCancel={this.liftBanCancel}
                    width="300px"
                    centered
                >
                    确定要解禁吗？
                </Modal>
            </div>
        );
    }
}

export default UserManagementSys;